// 自定义 Element Plus 主题色
export default defineNuxtPlugin(() => {
  // 在客户端运行时添加自定义样式
  if (process.client) {
    const style = document.createElement('style')
    style.innerHTML = `
      :root {
        --el-color-primary: #41CB5A !important;
        --el-color-primary-light-3: #6cd97f !important;
        --el-color-primary-light-5: #97e6a4 !important;
        --el-color-primary-light-7: #c2f2c9 !important;
        --el-color-primary-light-8: #d5f7da !important;
        --el-color-primary-light-9: #e9fbec !important;
        --el-color-primary-dark-2: #34a248 !important;
      }
    `
    document.head.appendChild(style)
  }
})
